/* eslint-disable no-sparse-arrays */
import React, { useState, useCallback, useMemo } from 'react'
import {
  Box,
  Drawer,
  SpacedPaper,
  HeaderTertiary,
  List,
  ListItem,
  ListItemButton,
  Button,
  GameButton
} from '@fedsim/components'
import { useNavigate } from 'react-router-dom'
import { routesList } from 'constants/routes'

import { trackEv, Categories, Actions } from 'analytics'
import { MenuOpen } from 'icons'

export const anchor = 'right'

export function LayoutDrawer() {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const closeDrawer = () => setOpen(false)
  const toggleDrawer = useCallback(() => setOpen(!open), [open])
  const nav = useMemo(() => path => {
    // !sticky &&
    trackEv(Categories.Sidebar, Actions.Navigate, { label: path })

    toggleDrawer()
    navigate(path)
  }, [navigate, toggleDrawer])
  const tools = [
    {
      title: 'The Office',
      onClick: () => nav(routesList.OFFICE.path)
    },
    {
      title: 'Draft',
      onClick: () => nav(routesList.DRAFT.path.replace('/*', '/start'))
    },
  ]

  const listPages = [
    {
      title: 'Rumbles',
      onClick: () => nav(routesList.RUMBLES.path.replace('/*', ''))
    },
    {
      title: 'Productions',
      onClick: () => nav(routesList.PRODUCTION_SELECT.path.replace('/*', ''))
    },
    {
      title: 'Ratings',
      onClick: () => nav(routesList.RATINGS.path)
    }
  ]

  const quickChange = [
    {
      title: 'Alignment',
      onClick: () => nav(routesList.ALIGNMENT.path)
    },
    {
      title: 'Repoint',
      onClick: () => nav('/repoint')
    },
    {
      title: 'Simulate',
      onClick: () => nav(routesList.SIMULATE.path)
    },
  ]

  const overviewPages = [
    {
      title: 'Feuds',
      onClick: () => nav(routesList.FEUDS_PLANNER.path)
    },
    {
      title: 'Reigns',
      onClick: () => nav(routesList.REIGNS.path)
    },
    {
      title: 'Arenas',
      onClick: () => nav(routesList.ARENAS.path)
    },
  ]
  const create = [
    {
      title: 'Rumble',
      onClick: () => nav('/rumbles/create')
    },
    {
      title: 'Production',
      onClick: () => nav('/production/create')
    },
    {
      title: 'Tournament',
      onClick: () => nav('/tournaments')
    },
    {
      title: 'Match',
      onClick: () => nav(routesList.MATCH.path.replace('/*', ''))
    },
    {
      title: 'Round of Cards',
      onClick: () => nav(routesList.CARDS.path)
    },
  ]
  const cms = [
    {
      title: 'CMS',
      onClick: () => nav('/dashboard')
    },
    {
      title: 'Setup',
      onClick: () => nav(routesList.SETUP.path.replace('/*', '/setup'))
    },
  ]

  const settings = [
    ...cms,
    {
      title: 'Blog',
      onClick: () => nav(routesList.BLOG.path.replace('/*', '/blog'))
    },
    {
      title: 'Migrations',
      onClick: () => nav(routesList.MIGRATIONS.path.replace('/*', '/migrations'))
    },
    {
      title: 'Settings',
      onClick: () => nav(routesList.SETTINGS.path)
    }
  ]

  const options = [
    {
      title: 'Tools',
      collection: tools,
    },
    {
      title: 'Listing',
      collection: listPages,
    },
    {
      title: 'Quick Change',
      collection: quickChange,
    },
    {
      title: 'Overview',
      collection: overviewPages,
    },
    {
      title: 'Create a...',
      collection: create,
    },
    {
      title: 'Settings',
      collection: settings,
    },
  ]

  return (
    <Box>
      <Button
        sx={{
          // color: 'white',
          boxShadow: 0,
          // backgroundColor: '#666',
          border: 'none',
          '&:hover': {
            border: 'none',
            boxShadow: 0,
            // backgroundColor: '#333',
          }
        }}
        aria-controls="positioned-menu"
        aria-haspopup="true"
        variant="filled"
        fullWidth
        onClick={toggleDrawer}
        startIcon={<MenuOpen />}
      >
        Menu
      </Button>
      <Drawer
        anchor={anchor}
        open={open}
        onClose={closeDrawer}
        sx={{
          root: {
            zIndex: 1000,
          },
        }}
      >
        <Box
          role="presentation"
          sx={{
            top: 100,
            width: {
              xs: '100%',
              sm: 300,
            }
          }}
        >
          <Box sx={{
            marginTop: -1,
            p: 0,
          }}>
            <List component="nav" dense>
              {options.map((item, index) => {
                return (
                  <ListItem key={`${index}-${item.title}`}
                    disablePadding
                    sx={{
                      flexDirection: "column",
                      alignItems: "flex-start",
                      p: 0,
                      m: 0,
                    }}>
                    <SpacedPaper sx={{
                      borderRadius: 0,
                      width: "100%",
                    }}>
                      <HeaderTertiary>{item.title}</HeaderTertiary>
                    </SpacedPaper>
                    <List dense component="nav" sx={{
                      width: "100%"
                    }}>
                      {item?.collection?.map((item, index) => (
                        <ListItem
                          key={index}
                          sx={{
                            width: "100%",
                            p: 0,
                            m: 0,
                          }}>
                          <ListItemButton key={item.title} onClick={item.onClick} sx={{
                            lineHeight: 1,
                            py: .8,
                            m: 0,
                            mb: 0.3,
                            width: "100%"
                          }}>
                            {item.title}
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </List>
                  </ListItem>
                )
              })}
            </List>
            <Box px={2}>
              <GameButton
                onClick={closeDrawer}
                fullWidth
                color="error"
                variant="contained"
                sx={{
                  zIndex: 1000,
                  width: "100%",
                }}
              >
                Close
              </GameButton>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Box>
  )
}

export default LayoutDrawer
